import { useEffect } from 'react';

import { RnsEventBus } from 'features/call/call-events';
import { useColdHandoffRnsHandlers } from 'features/cold-handoff/hooks';
import { useWhileComponentMounted } from 'features/utils/hook';

export const useColdHandoffAcceptedRnsHandlers = () => {
  const whileComponentMounted = useWhileComponentMounted();
  const { handleColdHandoffCanceledRequestingUser } =
    useColdHandoffRnsHandlers();

  useEffect(() => {
    RnsEventBus.$coldHandoffCanceled
      .pipe(whileComponentMounted())
      .subscribe(handleColdHandoffCanceledRequestingUser);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
